import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import Address from '../../molecules/Address';
import InputField from '../../molecules/InputField';
import TextGroup from '../../molecules/TextGroup';

import styles from './CompleteProfileBlock.module.scss';
import usePresenter from './CompleteProfileBlock.presenter';
import getProps from './CompleteProfileBlock.props';
import { CompleteProfileBlockCombinedProps } from './types';


const CompleteProfileBlock: React.FC<CompleteProfileBlockCombinedProps> = (props) => {
  const {
    className,
    classes,
    stepperText,
    textGroup,
    emailInputField,
    address,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.completeProfileBlock;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <Text
          className={cx(styles.stepperText, classes?.stepperText)}
          {...internalProps.stepperText}
          {...stepperText}/>
        <TextGroup
          className={cx(styles.textGroup, classes?.textGroup)}
          {...internalProps.textGroup}
          {...textGroup}/>
      </div>
      <div className={cx(styles.middleContent, classes?.middleContent)}>
        <InputField
          className={cx(styles.emailInputField, classes?.emailInputField)}
          {...internalProps.emailInputField}
          {...emailInputField}/>
        <Address
          className={cx(styles.address, classes?.address)}
          {...internalProps.address}
          {...address}/>
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
      </div>
    </div>
  );
};

export default CompleteProfileBlock;

